import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {IStore} from '../../../../shared/shared-models/store/store';
import {Store} from '@ngrx/store';
import {setSelectedStore} from '../../../../features/user-access/user-stores-store/user-store.actions';

@Component({
  selector: 'app-shared-store-tabs',
  templateUrl: './shared-store-tabs.component.html',
  styleUrls: ['./shared-store-tabs.component.scss'],
  standalone: false,
})
export class SharedStoreTabsComponent implements AfterViewInit {
  @Input() showFreshnessIndicator?: boolean;
  @Input() dataTimeStampKey?: string[] = [];
  @Input() isModal?: boolean = false;
  @Input() isMessagesModal = false;
  @Input() requiredConfirmation = false;
  @Output() readonly emitStoreChange: EventEmitter<IStore> = new EventEmitter<IStore>();
  stores: IStore[] = [];
  selectedStore: IStore | null = null;
  private pendingStoreId: string;

  constructor(private readonly store: Store) {
  }

  get getStores(): IStore[] {
    return this.stores;
  }

  get getSelectedStore(): IStore {
    return this.selectedStore;
  }

  @Input() set setUserSelectedStore(store: IStore | null) {
    this.pendingStoreId = store?.storeId ?? null;
    this.trySelectStore();
  }

  @Input() set setStores(stores: IStore[]) {
    if (!Array.isArray(stores)) {
      this.stores = [];
      return;
    }
    const seen = new Set<string>();
    const unique = stores.filter((store: IStore) => {
      const key = store.name.toLowerCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    this.stores = unique;
    this.trySelectStore();
  }

  onStoreChange(newStore: IStore): void {
    if (newStore) {
      if (this.requiredConfirmation) {
        this.emitStoreChange.emit(newStore);
      } else {
        this.selectedStore = newStore;
        this.emitStoreChange.emit(newStore);
        if (!this.isModal) {
          this.store.dispatch(setSelectedStore({selectedStore: newStore}));
        }
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.trySelectStore();
    }, 500);
  }

  getTabMaxWidth(): string {
    const tabCount = this.stores.length;
    if (tabCount > 6) {
      return '100px';
    }
    return `calc(600px / ${tabCount})`;
  }


  private trySelectStore(): void {
    if (!this.stores.length) return;

    let hasChanged = false;

    if (this.pendingStoreId) {
      const found = this.stores.find((s: IStore) => s.storeId === this.pendingStoreId);
      if (found) {
        this.selectedStore = found;
        hasChanged = true;
      } else {
        this.selectedStore = this.stores[0];
        hasChanged = true;
      }
      this.pendingStoreId = null;
    }

    if (!this.selectedStore) {
      return;
    }

    if (hasChanged) {
      this.emitStoreChange.emit(this.selectedStore);
      this.store.dispatch(setSelectedStore({selectedStore: this.selectedStore}));
    }
  }
}


